import React from "react";
let user;
export default user = React.createContext({user:null});